import * as React from "react";

const SvgIcnDefaultAvatar = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="currentColor" strokeWidth={1.2} fill="none" fillRule="evenodd">
            <circle cx={12} cy={7.896} r={5.26} />
            <path
                d="M9.662 9.638c.778.78 1.557 1.17 2.338 1.17.782 0 1.564-.39 2.348-1.17M4.499 21.337c.04-2.067.774-3.756 2.199-5.067C8.123 14.958 9.89 14.31 12 14.325M19.501 21.338c-.04-2.067-.774-3.757-2.199-5.068-1.425-1.312-3.192-1.96-5.302-1.945"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);

export default SvgIcnDefaultAvatar;
